function FacebookIcon({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M56 28.001C56 35.7322 52.8654 42.7315 47.7984 47.7984C43.4361 52.1608 37.6411 55.0904 31.1805 55.8204C30.1363 55.9395 29.0745 56 27.9991 56C25.5807 56 23.2346 55.6936 20.9959 55.1158C8.91988 52.0085 0 41.047 0 28.001C0 20.2698 3.13464 13.2686 8.19965 8.2016C13.2666 3.13464 20.2679 0 27.9991 0C35.7303 0 42.7315 3.13464 47.7984 8.2016C52.8654 13.2686 56 20.2698 56 28.001Z" fill="#0866FF"/>
      <path d="M31.214 23.6795V27.3938H40.3291L38.7266 35.8667H31.1808V55.8203C30.1366 55.9394 29.0748 55.9999 27.9994 55.9999C25.5811 55.9999 23.2349 55.6935 20.9962 55.1157V35.8999H15.2207V27.3938H20.9962C20.84 18.7043 21.7652 13.731 27.2733 11.0921C32.7833 8.45522 40.78 10.4129 40.78 10.4129V18.1871C40.78 18.1871 39.1599 18.0699 37.1905 18.0699C35.2192 18.0699 33.6421 18.5306 32.4983 19.7563C31.2023 21.148 31.214 23.6795 31.214 23.6795Z" fill="white"/>
    </svg>

  `;

  return baseXml;
}

export default FacebookIcon;
